const churchForm = document.querySelector( '#modalChurchAdd form' );
const churchStore = ( obj ) => {
	const fd = new FormData( obj );
	axios.post( obj.action, fd, {
		headers: {
			'Content-Type': 'multipart/form-data'
		}
	} )
	     .then( r => {
		     obj.reset();
		     $( obj.closest( '.modal' ) ).modal( 'hide' );
		     location.reload();
	     } )
	     .catch( err => {
		     console.log( err.response ? err.response : err );
		     if ( err.response && err.response.status === 403 ) {
			     alert( '교회를 추가할 권한이 없습니다.' );
			     return false;
		     }
		     else {
			     alert( '오류 발생 : ' + err.response ? err.response.data.message : err.message );
		     }
	     } )
};

if ( churchForm ) {
	churchForm.addEventListener( 'submit', e => {
		e.preventDefault();
		churchStore( e.target );
	} );
}

// $('#modalChurchAdd').iziModal('open');

window.churchEdit = obj => {
	const action = obj.dataset.churchEdit;
	axios.get( action )
	     .then( r => {
		     const modal = document.querySelector( '#modalChurchEdit' );
		     const f = modal.querySelector( 'form' );
		     f.reset();
		     f.action = '/churches/update/' + r.data.id;
		     f.church_name.value = r.data.church_name;
		     f.senior_pastor.value = r.data.senior_pastor;
		     f.homepage.value = r.data.homepage;
		     f.sermon_url.value = r.data.sermon_url;
		     f.resource_url.value = r.data.resource_url;
		     f.row_dom.value = r.data.row_dom;
		     f.link_dom.value = r.data.link_dom;
		     f.thumbnail_dom.value = r.data.thumbnail_dom;
		     f.sermon_title.value = r.data.sermon_title;
		     f.preacher.value = r.data.preacher;
		     f.bible.value = r.data.bible;
		     f.sermon_date.value = r.data.sermon_date;
		     f.no_crawling.checked = r.data.no_crawling;


		     if ( r.data.logo ) {
			     let logo = document.createElement( 'img' );
			     logo.setAttribute( 'src', 'https://s3.ap-northeast-2.amazonaws.com/ngeneration.net/' + r.data.logo );
			     logo.classList.add( 'img-fluid' );
			     modal.querySelector( '.full-background' ).appendChild( logo );
		     }

		     $( modal ).iziModal( 'open' );
	     } )
	     .catch( err => {
		     alert( '오류 : ' + err.response ? err.response.data.message : err.message );
		     console.error( err.response ? err.response : err );
	     } )
};

if ( document.querySelector( '#churchUpdateForm' ) ) {
	document.querySelector( '#churchUpdateForm' ).addEventListener( 'submit', e => {

		e.preventDefault();

		let fd = new FormData( e.target );

		axios.post( e.target.action, fd, {
			headers: {
				'Content-Type': 'multipart/form-data'
			}
		} )
		     .then( r => {
			     location.reload();
		     } )
		     .catch( err => {
			     console.error( err.response );
			     if ( err.response && err.response.data.message ) {
				     alert( err.response.data.message );
			     }
			     else {
				     alert( '오류 발생 : ' + err.message );
			     }
		     } )
	} );
}

window.churchDestroy = obj => {
	if ( !confirm( '삭제할까요?' ) ) return false;

	axios.delete( obj.dataset.churchDestroy )
	     .then( r => {
		     obj.closest( '.church-item' ).remove();
	     } )
	     .catch( err => {
		     alert( '오류 : ' + err.response ? err.response.data.message : err.message );
	     } );
};

window.getFeaturedImage = async ( url ) => {
	return await axios.get( url );
};

window.decodeHtml = ( html ) => {
	let txt = document.createElement( 'textarea' );
	txt.innerHTML = html;

	return txt.value;
};

window.domParsing = ( obj, url, dom ) => {
	console.log( obj );
	let htmlContent = obj.html;
	let parser = new DOMParser();
	let parsedHtml = parser.parseFromString( htmlContent, 'text/html' );

	const items = [];

	if ( url.match( /\/wp-json\//gi ) && url.match( /\/wp-json\//gi ).length > 0 ) {
		// 워드프레스의 경우 rest api call
		$.each(JSON.parse( htmlContent ), function(){
			let item = this;
			const sermonItem = {
				thumbnail: '/assets/img/no-img/pulfit.jpg',
				title: item.title.rendered.replace( /\&\#[\d]{4}\;/gi, '' ).trim(),
				bible: '',
				preacher: '',
				date: moment.utc( item.date ).local().format( 'YYYY-MM-DD' ),
				link: item.link
			};

			const itemTpl = document.querySelector( '.sermon-item' ).cloneNode( true );
			itemTpl.querySelector( '.sermon-thumbnail-wrapper a' ).href = sermonItem.link;
			itemTpl.querySelector( '.sermon-thumbnail-wrapper img' ).setAttribute( 'src', sermonItem.thumbnail );
			sermonItem.title ? itemTpl.querySelector( '.sermon-title h4' ).textContent = sermonItem.title : '';
			sermonItem.bible
					? itemTpl.querySelector( '.sermon-bible' ).textContent = sermonItem.bible
					: $(itemTpl).find( '.sermon-bible' ).remove();
			sermonItem.date
					? itemTpl.querySelector( '.sermon-date' ).textContent = sermonItem.date
					: $(itemTpl).find( '.sermon-date' ).remove();
			sermonItem.preacher
					? itemTpl.querySelector( '.sermon-preacher' ).textContent = sermonItem.preacher
					: $(itemTpl).find( '.sermon-preacher' ).remove();
			sermonItem.link
					? itemTpl.querySelector( '.sermon-link' ).setAttribute( 'href', sermonItem.link )
					: '';
			itemTpl.querySelector( '.sermon-link' ).setAttribute( 'target', '_blank' );
			itemTpl.style.display = '';
			items.push( itemTpl );
		});

	}
	else {
		//일반 사이트의 경우

		let rows = parsedHtml.querySelectorAll( decodeHtml( dom.row ) );
		$.each(rows, function(){
			let el = this;
			let thumbnail = dom.thumbnail && el.querySelector( decodeHtml( dom.thumbnail ) )
					? el.querySelector( decodeHtml( dom.thumbnail ) ).src
					: null;
			let sermonTitle = dom.title && el.querySelector( decodeHtml( dom.title ) )
					? el.querySelector( decodeHtml( dom.title ) ).textContent
					: null;
			let sermonBible = dom.bible && el.querySelector( decodeHtml( dom.bible ) )
					? el.querySelector( decodeHtml( dom.bible ) ).textContent
					: null;
			let sermonPreacher = dom.preacher && el.querySelector( decodeHtml( dom.preacher ) )
					? el.querySelector( decodeHtml( dom.preacher ) ).textContent
					: null;
			let sermonDate = dom.date && el.querySelector( decodeHtml( dom.date ) )
					? el.querySelector( decodeHtml( dom.date ) ).textContent
					: null;
			let sermonLink = dom.link && el.querySelector( decodeHtml( dom.link ) )
					? el.querySelector( decodeHtml( dom.link ) )
					: null;


			if ( dom.thumbnail && el.querySelector( decodeHtml( dom.thumbnail ) ) ) {
				if ( el.querySelector( decodeHtml( dom.thumbnail ) ).style.backgroundImage ) {
					let bgImg = el.querySelector( decodeHtml( dom.thumbnail ) ).style.backgroundImage;
					if ( bgImg.match( /https?:\/\/.+(jpe?g|png|gif|bpm)/ ) ) {
						thumbnail = bgImg.match( /https?:\/\/.+(jpe?g|png|gif|bpm)/ )[ 0 ];
					}
				}
			}

			if ( sermonTitle && sermonTitle.match( /\s\"[\d,\D]+\"\s/ ) ) {
				sermonTitle = sermonTitle.match( /\s(\"|\“)[\d,\D]+(\"|\”)\s/ )[ 0 ].trim();
			}
			else if ( sermonTitle && sermonTitle.match( /(^\[).+(\])(.+)(\/).+/i ) ) {
				sermonTitle = sermonTitle.replace( /(^\[).+(\])(.+)(\/).+/i, '$3' );
			}
			else if ( sermonTitle && sermonTitle.match( /([\d]{4}\년\s[\d]{1,2}\월\s[\d]{1,2}일)(.+)/gi ) ) {
				sermonTitle = sermonTitle.replace( /([\d]{4}\년\s[\d]{1,2}\월\s[\d]{1,2}일)(.+)/gi, '$2' );
			}

			let reg = /본문\s\:\s[\D,\d,\s]+(절)/i;
			if ( null !== sermonBible && sermonBible.match( reg ) ) {
				sermonBible = sermonBible.match( reg )[ 0 ].trim();
				sermonBible = sermonBible.replace( /(본문)\s\:\s/i, '' );
			}
			else if ( sermonBible && sermonBible.match( /\n[\D]{1,7}\s[\d]{1,3}\:[\d]{1,2}\-[\d]{1,3}/gi ) ) {
				sermonBible = sermonBible.match( /\n[\D]{1,7}\s[\d]{1,3}\:[\d]{1,2}\-[\d]{1,3}/gi )[ 0 ];
			}
			else if ( sermonBible && sermonBible.match( /\([\D]{1,3}\s[0-9]{1,3}\:[0-9,-,~]+\)/gi ) ) {
				sermonBible = sermonBible.match( /\([\D]{1,2}\s[0-9]{1,3}\:[0-9,-,~]+\)/gi )[ 0 ];
			}
			else if ( sermonBible && sermonBible.match( /\s?(\/)?\s?[\D]{1,7}\s?[\d, \:, \-, \~, ^\)]+\…?$/gi ) ) {
				if ( sermonBible.split( '/' ).length > 0 ) {
					sermonBible = sermonBible.split( '/' )[ sermonBible.split( '/' ).length - 1 ];
				}
			}
			else if ( sermonBible && sermonBible.match( /(.+)(\s\/.+\…)/gi ) ) {
				sermonBible = sermonBible.match( /(.+)(\s\/.+\…)/gi )[ 0 ].split( '/' )[ sermonBible.match( /(.+)(\s\/.+\…)/gi )[ 0 ].split( '/' ).length - 1 ];
			}


			if ( null !== sermonPreacher && sermonPreacher.match( /설교자+[\d,\D,\s]+목사/i ) ) {
				sermonPreacher = sermonPreacher.match( /설교자+[\d,\D,\s]+목사/i )[ 0 ].trim();
				sermonPreacher = sermonPreacher.replace( /(설교자)\s\:\s/i, '' );
			}
			else if ( sermonPreacher && sermonPreacher.match( /[\D]{3,4}\s(목사|감독|감리사|전도사)/gi ) ) {
				sermonPreacher = sermonPreacher.match( /[\D]{3,4}\s(목사|감독|감리사|전도사)/gi )[ 0 ].replace( /(\(|\))/gi, '' );
			}
			else if ( sermonPreacher && sermonPreacher.match( /[\W]{1,4}\s?(담임)?(목사)/gi ) ) {
				sermonPreacher = sermonPreacher.match( /[\W]{1,4}\s?(담임)?(목사)/gi )[ 0 ];
			}


			let reg3 = /날짜\s\:\s[\d,\-]+/i;
			if ( null !== sermonDate && sermonDate.match( reg3 ) ) {
				sermonDate = sermonDate.match( reg3 )[ 0 ];
				sermonDate = sermonDate.replace( /(날짜)\s\:\s/, '' );
			}
			else if ( sermonDate && sermonDate.match( /[0-9]{4}\.\s[0-9]{2}\.\s[0-9]{2}/gi ) ) {
				sermonDate = sermonDate.match( /[0-9]{4}\.\s[0-9]{2}\.\s[0-9]{2}/gi )[ 0 ];
			}
			else if ( sermonDate && sermonDate.match( /[\d]{4}\/[\d]{2}\/[\d]{2}/gi ) ) {
				sermonDate = sermonDate.match( /[\d]{4}\/[\d]{2}\/[\d]{2}/gi )[ 0 ];
			}
			else if ( sermonDate && sermonDate.match( /^[\d]{4}\년\s[\d]{1,2}\월\s[\d]{1,2}\일/gi ) ) {
				sermonDate = sermonDate.match( /^[\d]{4}\년\s[\d]{1,2}\월\s[\d]{1,2}\일/gi )[ 0 ];
			}

			// 층주남부교회 (교회사랑넷 old버전)
			if ( el.querySelectorAll( '.typeWebzineText2 > .typeWebzineTextContents > p > .s002' ).length > 0 ) {
				sermonDate = el.querySelectorAll( '.typeWebzineText2 > .typeWebzineTextContents > p > .s002' )[ 0 ].innerText;
				sermonBible = el.querySelectorAll( '.typeWebzineText2 > .typeWebzineTextContents > p > .s002' )[ 1 ].innerText;
			}

			let domain = '';
			if ( url.match( /vimeo.com/gi ) && url.match( /vimeo.com/gi ).length > 0 ) {
				domain = 'https://vimeo.com';
			}
			else if ( url.match( /(youtube.com|youtu.be)/gi ) && url.match( /(youtube.com|youtu.be)/gi ).length > 0 ) {
				domain = 'https://youtube.com';
			}
			else {
				if ( url.match( /^https?\:\/\/[a-z,0-9]+\.[a-z,0-9]+\.[a-z]{2,3}/ ) ) {
					domain = url.match( /^https?\:\/\/[a-z,0-9]+\.[a-z,0-9]+\.[a-z]{2,3}/ )[ 0 ];
				}
				if ( url.match( /^https?:\/\/[a-z,0-9,-,_]+\.(com|net|org|or.kr|kr)/ ) ) {
					domain = url.match( /^https?:\/\/[a-z,0-9,-,_]+\.(com|net|org|or.kr|kr|co.kr)/ )[ 0 ];
				}
			}

			switch ( domain ) {
				case "https://vimeo.com" :
					sermonLink = domain + sermonLink.href.replace( location.origin, '' );
					sermonDate = dom.date && el.querySelector( dom.date ) ? el.querySelector( dom.date ).getAttribute( 'datetime' ) : '';
					sermonDate = moment.utc( sermonDate ).local();
					sermonDate = sermonDate.format( 'YYYY-MM-DD' );
					break;

				case "https://youtube.com" :
					sermonLink = domain + sermonLink.href.replace( location.origin, '' );
					break;

				default :

					if ( null === sermonLink ) {
						sermonLink = 'javascript:confirm(\'이 홈페이지는 링크를 처리할 수 없습니다.\n확인을 클릭하시면 홈페이지로 이동합니다.\') ? window.open(\'' + url + '\') : ""';
					}
					else if ( sermonLink.getAttribute( 'onclick' ) ) {
						// onclick으로 처리하는 경우
						sermonLink = domain + sermonLink.getAttribute( 'onclick' ).match( /\'.*.\'/ )[ 0 ].replace( /\'/gi, '' );
					}
					else if ( sermonLink.hasAttribute( 'href' ) ) {
						if ( sermonLink.href.match( /javascript:vod.vodView[\d,\D]+/gi ) ) {
							sermonLink = 'javascript:confirm(\'이 홈페이지는 링크를 처리할 수 없습니다.\n확인을 클릭하시면 홈페이지로 이동합니다.\') ? window.open(\'' + url + '\') : ""';
						}
						else if ( sermonLink.href.match( /javascript:document\.location\.href/gi ) ) {
							// javascript:document.location.href로 링크를 처리하는 경우
							sermonLink = domain + sermonLink.href.replace( /(javascript\:document\.location\.href=)\'([\w,\W]+)\'/gi, '$2' );
						}
						else {

							if ( sermonLink.href.match( /(http:\/\/localhost:3000|https:\/\/ngeneration.net)/gi ) ) {
								sermonLink = sermonLink.href.replace( /(http:\/\/localhost:3000|https:\/\/ngeneration.net)/, domain );
							}
							else if ( sermonLink.href.match( /^http/i ) ) {
								sermonLink = sermonLink.href;
							}

							else {
								sermonLink = domain + sermonLink.href;
							}
						}
					}
					else {
						sermonLink = 'javascript:confirm(\'이 홈페이지는 링크를 처리할 수 없습니다.\n확인을 클릭하시면 홈페이지로 이동합니다.\') ? window.open(\'' + url + '\') : ""';
					}
			}


			if ( el.querySelector( decodeHtml( dom.title ) ) ) {

				const sermonItem = {
					thumbnail: null !== thumbnail ? thumbnail : '',
					title: sermonTitle ? sermonTitle.trim() : '',
					bible: sermonBible ? sermonBible.trim() : '',
					preacher: sermonPreacher ? sermonPreacher.trim() : '',
					date: sermonDate ? sermonDate.trim() : '',
					link: sermonLink ? sermonLink : ''
				};

				const itemTpl = document.querySelector( '.sermon-item' ).cloneNode( true );
				itemTpl.querySelector( '.sermon-thumbnail-wrapper a' ).href = sermonLink;
				itemTpl.querySelector( '.sermon-thumbnail-wrapper img' ).setAttribute( 'src', sermonItem.thumbnail ? sermonItem.thumbnail : '/assets/img/no-img/pulfit.jpg' );
				sermonItem.title ? itemTpl.querySelector( '.sermon-title h4' ).textContent = sermonItem.title : '';
				sermonItem.bible
						? itemTpl.querySelector( '.sermon-bible' ).textContent = sermonItem.bible
						: $(itemTpl).find( '.sermon-bible' ).remove();
				sermonItem.date
						? itemTpl.querySelector( '.sermon-date' ).textContent = sermonItem.date
						: $(itemTpl).find( '.sermon-date' ).remove();
				sermonItem.preacher
						? itemTpl.querySelector( '.sermon-preacher' ).textContent = sermonItem.preacher
						: $(itemTpl).find( '.sermon-preacher' ).remove();

				sermonItem.link
						? itemTpl.querySelector( '.sermon-link' ).setAttribute( 'href', sermonItem.link )
						: $(itemTpl).find( '.sermon-link' ).remove();
				itemTpl.querySelector( '.sermon-link' ).setAttribute( 'target', '_blank' );
				itemTpl.style.display = '';
				items.push( itemTpl );
			}
		});
		/*if ( rows.length > 0 ) {

			rows.forEach( ( el, index ) => {

				let thumbnail = dom.thumbnail && el.querySelector( decodeHtml( dom.thumbnail ) )
						? el.querySelector( decodeHtml( dom.thumbnail ) ).src
						: null;
				let sermonTitle = dom.title && el.querySelector( decodeHtml( dom.title ) )
						? el.querySelector( decodeHtml( dom.title ) ).textContent
						: null;
				let sermonBible = dom.bible && el.querySelector( decodeHtml( dom.bible ) )
						? el.querySelector( decodeHtml( dom.bible ) ).textContent
						: null;
				let sermonPreacher = dom.preacher && el.querySelector( decodeHtml( dom.preacher ) )
						? el.querySelector( decodeHtml( dom.preacher ) ).textContent
						: null;
				let sermonDate = dom.date && el.querySelector( decodeHtml( dom.date ) )
						? el.querySelector( decodeHtml( dom.date ) ).textContent
						: null;
				let sermonLink = dom.link && el.querySelector( decodeHtml( dom.link ) )
						? el.querySelector( decodeHtml( dom.link ) )
						: null;


				if ( dom.thumbnail && el.querySelector( decodeHtml( dom.thumbnail ) ) ) {
					if ( el.querySelector( decodeHtml( dom.thumbnail ) ).style.backgroundImage ) {
						let bgImg = el.querySelector( decodeHtml( dom.thumbnail ) ).style.backgroundImage;
						if ( bgImg.match( /https?:\/\/.+(jpe?g|png|gif|bpm)/ ) ) {
							thumbnail = bgImg.match( /https?:\/\/.+(jpe?g|png|gif|bpm)/ )[ 0 ];
						}
					}
				}

				if ( sermonTitle && sermonTitle.match( /\s\"[\d,\D]+\"\s/ ) ) {
					sermonTitle = sermonTitle.match( /\s(\"|\“)[\d,\D]+(\"|\”)\s/ )[ 0 ].trim();
				}
				else if ( sermonTitle && sermonTitle.match( /(^\[).+(\])(.+)(\/).+/i ) ) {
					sermonTitle = sermonTitle.replace( /(^\[).+(\])(.+)(\/).+/i, '$3' );
				}
				else if ( sermonTitle && sermonTitle.match( /([\d]{4}\년\s[\d]{1,2}\월\s[\d]{1,2}일)(.+)/gi ) ) {
					sermonTitle = sermonTitle.replace( /([\d]{4}\년\s[\d]{1,2}\월\s[\d]{1,2}일)(.+)/gi, '$2' );
				}

				let reg = /본문\s\:\s[\D,\d,\s]+(절)/i;
				if ( null !== sermonBible && sermonBible.match( reg ) ) {
					sermonBible = sermonBible.match( reg )[ 0 ].trim();
					sermonBible = sermonBible.replace( /(본문)\s\:\s/i, '' );
				}
				else if ( sermonBible && sermonBible.match( /\n[\D]{1,7}\s[\d]{1,3}\:[\d]{1,2}\-[\d]{1,3}/gi ) ) {
					sermonBible = sermonBible.match( /\n[\D]{1,7}\s[\d]{1,3}\:[\d]{1,2}\-[\d]{1,3}/gi )[ 0 ];
				}
				else if ( sermonBible && sermonBible.match( /\([\D]{1,3}\s[0-9]{1,3}\:[0-9,-,~]+\)/gi ) ) {
					sermonBible = sermonBible.match( /\([\D]{1,2}\s[0-9]{1,3}\:[0-9,-,~]+\)/gi )[ 0 ];
				}
				else if ( sermonBible && sermonBible.match( /\s?(\/)?\s?[\D]{1,7}\s?[\d, \:, \-, \~, ^\)]+\…?$/gi ) ) {
					if ( sermonBible.split( '/' ).length > 0 ) {
						sermonBible = sermonBible.split( '/' )[ sermonBible.split( '/' ).length - 1 ];
					}
				}
				else if ( sermonBible && sermonBible.match( /(.+)(\s\/.+\…)/gi ) ) {
					sermonBible = sermonBible.match( /(.+)(\s\/.+\…)/gi )[ 0 ].split( '/' )[ sermonBible.match( /(.+)(\s\/.+\…)/gi )[ 0 ].split( '/' ).length - 1 ];
				}


				if ( null !== sermonPreacher && sermonPreacher.match( /설교자+[\d,\D,\s]+목사/i ) ) {
					sermonPreacher = sermonPreacher.match( /설교자+[\d,\D,\s]+목사/i )[ 0 ].trim();
					sermonPreacher = sermonPreacher.replace( /(설교자)\s\:\s/i, '' );
				}
				else if ( sermonPreacher && sermonPreacher.match( /[\D]{3,4}\s(목사|감독|감리사|전도사)/gi ) ) {
					sermonPreacher = sermonPreacher.match( /[\D]{3,4}\s(목사|감독|감리사|전도사)/gi )[ 0 ].replace( /(\(|\))/gi, '' );
				}
				else if ( sermonPreacher && sermonPreacher.match( /[\W]{1,4}\s?(담임)?(목사)/gi ) ) {
					sermonPreacher = sermonPreacher.match( /[\W]{1,4}\s?(담임)?(목사)/gi )[ 0 ];
				}


				let reg3 = /날짜\s\:\s[\d,\-]+/i;
				if ( null !== sermonDate && sermonDate.match( reg3 ) ) {
					sermonDate = sermonDate.match( reg3 )[ 0 ];
					sermonDate = sermonDate.replace( /(날짜)\s\:\s/, '' );
				}
				else if ( sermonDate && sermonDate.match( /[0-9]{4}\.\s[0-9]{2}\.\s[0-9]{2}/gi ) ) {
					sermonDate = sermonDate.match( /[0-9]{4}\.\s[0-9]{2}\.\s[0-9]{2}/gi )[ 0 ];
				}
				else if ( sermonDate && sermonDate.match( /[\d]{4}\/[\d]{2}\/[\d]{2}/gi ) ) {
					sermonDate = sermonDate.match( /[\d]{4}\/[\d]{2}\/[\d]{2}/gi )[ 0 ];
				}
				else if ( sermonDate && sermonDate.match( /^[\d]{4}\년\s[\d]{1,2}\월\s[\d]{1,2}\일/gi ) ) {
					sermonDate = sermonDate.match( /^[\d]{4}\년\s[\d]{1,2}\월\s[\d]{1,2}\일/gi )[ 0 ];
				}

				// 층주남부교회 (교회사랑넷 old버전)
				if ( el.querySelectorAll( '.typeWebzineText2 > .typeWebzineTextContents > p > .s002' ).length > 0 ) {
					sermonDate = el.querySelectorAll( '.typeWebzineText2 > .typeWebzineTextContents > p > .s002' )[ 0 ].innerText;
					sermonBible = el.querySelectorAll( '.typeWebzineText2 > .typeWebzineTextContents > p > .s002' )[ 1 ].innerText;
				}

				let domain = '';
				if ( url.match( /vimeo.com/gi ) && url.match( /vimeo.com/gi ).length > 0 ) {
					domain = 'https://vimeo.com';
				}
				else if ( url.match( /(youtube.com|youtu.be)/gi ) && url.match( /(youtube.com|youtu.be)/gi ).length > 0 ) {
					domain = 'https://youtube.com';
				}
				else {
					if ( url.match( /^https?\:\/\/[a-z,0-9]+\.[a-z,0-9]+\.[a-z]{2,3}/ ) ) {
						domain = url.match( /^https?\:\/\/[a-z,0-9]+\.[a-z,0-9]+\.[a-z]{2,3}/ )[ 0 ];
					}
					if ( url.match( /^https?:\/\/[a-z,0-9,-,_]+\.(com|net|org|or.kr|kr)/ ) ) {
						domain = url.match( /^https?:\/\/[a-z,0-9,-,_]+\.(com|net|org|or.kr|kr|co.kr)/ )[ 0 ];
					}
				}

				switch ( domain ) {
					case "https://vimeo.com" :
						sermonLink = domain + sermonLink.href.replace( location.origin, '' );
						sermonDate = dom.date && el.querySelector( dom.date ) ? el.querySelector( dom.date ).getAttribute( 'datetime' ) : '';
						sermonDate = moment.utc( sermonDate ).local();
						sermonDate = sermonDate.format( 'YYYY-MM-DD' );
						break;

					case "https://youtube.com" :
						sermonLink = domain + sermonLink.href.replace( location.origin, '' );
						break;

					default :

						if ( null === sermonLink ) {
							sermonLink = 'javascript:confirm(\'이 홈페이지는 링크를 처리할 수 없습니다.\n확인을 클릭하시면 홈페이지로 이동합니다.\') ? window.open(\'' + url + '\') : ""';
						}
						else if ( sermonLink.getAttribute( 'onclick' ) ) {
							// onclick으로 처리하는 경우
							sermonLink = domain + sermonLink.getAttribute( 'onclick' ).match( /\'.*.\'/ )[ 0 ].replace( /\'/gi, '' );
						}
						else if ( sermonLink.hasAttribute( 'href' ) ) {
							if ( sermonLink.href.match( /javascript:vod.vodView[\d,\D]+/gi ) ) {
								sermonLink = 'javascript:confirm(\'이 홈페이지는 링크를 처리할 수 없습니다.\n확인을 클릭하시면 홈페이지로 이동합니다.\') ? window.open(\'' + url + '\') : ""';
							}
							else if ( sermonLink.href.match( /javascript:document\.location\.href/gi ) ) {
								// javascript:document.location.href로 링크를 처리하는 경우
								sermonLink = domain + sermonLink.href.replace( /(javascript\:document\.location\.href=)\'([\w,\W]+)\'/gi, '$2' );
							}
							else {

								if ( sermonLink.href.match( /(http:\/\/localhost:3000|https:\/\/ngeneration.net)/gi ) ) {
									sermonLink = sermonLink.href.replace( /(http:\/\/localhost:3000|https:\/\/ngeneration.net)/, domain );
								}
								else if ( sermonLink.href.match( /^http/i ) ) {
									sermonLink = sermonLink.href;
								}

								else {
									sermonLink = domain + sermonLink.href;
								}
							}
						}
						else {
							sermonLink = 'javascript:confirm(\'이 홈페이지는 링크를 처리할 수 없습니다.\n확인을 클릭하시면 홈페이지로 이동합니다.\') ? window.open(\'' + url + '\') : ""';
						}
				}


				if ( el.querySelector( decodeHtml( dom.title ) ) ) {

					const sermonItem = {
						thumbnail: null !== thumbnail ? thumbnail : '',
						title: sermonTitle ? sermonTitle.trim() : '',
						bible: sermonBible ? sermonBible.trim() : '',
						preacher: sermonPreacher ? sermonPreacher.trim() : '',
						date: sermonDate ? sermonDate.trim() : '',
						link: sermonLink ? sermonLink : ''
					};

					const itemTpl = document.querySelector( '.sermon-item' ).cloneNode( true );
					itemTpl.querySelector( '.sermon-thumbnail-wrapper a' ).href = sermonLink;
					itemTpl.querySelector( '.sermon-thumbnail-wrapper img' ).setAttribute( 'src', sermonItem.thumbnail ? sermonItem.thumbnail : '/assets/img/no-img/pulfit.jpg' );
					sermonItem.title ? itemTpl.querySelector( '.sermon-title h4' ).textContent = sermonItem.title : '';
					sermonItem.bible
							? itemTpl.querySelector( '.sermon-bible' ).textContent = sermonItem.bible
							: itemTpl.querySelector( '.sermon-bible' ).remove();
					sermonItem.date
							? itemTpl.querySelector( '.sermon-date' ).textContent = sermonItem.date
							: itemTpl.querySelector( '.sermon-date' ).remove();
					sermonItem.preacher
							? itemTpl.querySelector( '.sermon-preacher' ).textContent = sermonItem.preacher
							: itemTpl.querySelector( '.sermon-preacher' ).remove();

					sermonItem.link
							? itemTpl.querySelector( '.sermon-link' ).setAttribute( 'href', sermonItem.link )
							: itemTpl.querySelector( '.sermon-link' ).remove();
					itemTpl.querySelector( '.sermon-link' ).setAttribute( 'target', '_blank' );
					itemTpl.style.display = '';
					items.push( itemTpl );
				}

			} );

		}*/
	}

	let sermonList = document.getElementById( 'sermon-list' );
	sermonList.innerHTML = '';

	for ( let i = 0; i < items.length; ++i ) {
		if ( i > 7 ) {
			break;
		}

		sermonList.appendChild( items[ i ] );
	}
};

window.getContent = ( url, dom ) => {

	if ( !dom.row ) {
		let Img = document.createElement( 'img' );
		Img.src = '/assets/img/not-readysvg.svg';
		Img.classList.add( 'd-block', 'mx-auto', 'mb-5' );
		Img.style.width = '480px';

		document.getElementById( 'loader' ).appendChild( Img );
		document.getElementById( 'loader' ).querySelector( '.loader-icon-3' ).remove();
		document.getElementById( 'loader' ).querySelector( '.lead' ).textContent = '설교 불러오기 기능을 준비하고 있습니다.';

		return false;
	}

	$.ajax( {
		        url: '/api/crawling?url=' + url,
		        method: 'get',
		        dataType: 'json'
	        } )
	 .done( function ( r ) {
		 domParsing( r, url, dom );
	 } )
	 .fail( function ( err ) {
		 console.error( err.response ? err.response : err );
		 if ( err.response ) {
			 alert( err.response.data.message );
		 }
		 else if ( err.request ) {
			 alert( err.request.message );
		 }
		 else {
			 alert( err.message );
		 }
	 } );

	/*const html = axios.get( '/api/crawling?url=' + url )
	 .then(function(r){
	 domParsing(r);
	 })
	 .catch(function(err){
	 console.error( err.response ? err.response : err );
	 if ( err.response ) {
	 alert(err.response.data.message);
	 } else if ( err.request) {
	 alert(err.request.message);
	 } else {
	 alert(err.message);
	 }
	 })*/
};
